"use strict";

var _frameworkImportPath = require("@storybook/react");

/* eslint-disable import/no-unresolved */
(0, _frameworkImportPath.configure)([require.context('./src/stories', false, /^\.[\\/](?:(?!\.)(?=.)[^\\/]*?\.stories\.tsx)$/)], module, false);